import { render, staticRenderFns } from "./secondPart.vue?vue&type=template&id=150cfd69"
import script from "./secondPart.vue?vue&type=script&lang=js"
export * from "./secondPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports